import { TEXTS } from '@/views/PesosCocidos/cookedWeightsConstants'
import { formatKilograms, GRAMS_PER_KILOGRAM } from '@/utils/kilosFormat'
import { roundDownToGram } from '@/utils/mealServingTotals'

const DECIMAL_POINT = '.'
const DECIMAL_COMMA = ','

function hasWeight (grams) {
  return grams !== null && grams !== undefined
}

export function formatWeight (grams) {
  if (!hasWeight(grams)) {
    return TEXTS.EMPTY_CELL
  }
  const kilograms = formatKilograms(Number(grams)).replace(DECIMAL_POINT, DECIMAL_COMMA)
  return `${kilograms} ${TEXTS.KILOGRAMS_SUFFIX}`
}

export function kilogramTextToGrams (kilogramText) {
  return roundDownToGram(Number(kilogramText) * GRAMS_PER_KILOGRAM)
}

export function formatKilogramText (kilogramText) {
  return formatWeight(kilogramTextToGrams(kilogramText))
}

export function formatMinimumWeight (grams) {
  return hasWeight(grams) ? formatWeight(roundDownToGram(grams)) : TEXTS.EMPTY_CELL
}

export function formatServingGrams (grams) {
  return hasWeight(grams) ? `${roundDownToGram(grams)} ${TEXTS.GRAMS_SUFFIX}` : TEXTS.EMPTY_CELL
}
